import { createReducer } from '@ngrx/store';
import { initialRootState } from './root-state';

export const rootStateReducer = createReducer(
  initialRootState
);
